import React, { useContext } from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { StoreContext } from "../../store/Provider";

function NotToAdmin(props) {
  const context = useContext(StoreContext);
  if (context.omsUserData?.UserRoles.includes("Admin")) return <NotAccess />;
  return props.children;
}

export default NotToAdmin;
